// src/modules/services/SacService.js

import axios from "axios";
import AuthService from "./AuthService";
import { format } from 'date-fns';

// Objeto de mapeamento de tipos de ocorrência
export const tiposOcorrencia = {
    'DEVOLUCAO': [
        { label: 'APRESENTACAO DA MERCADORIA ERRADA', cdTipo: 7, cdSubtipo: 53 },
        // { label: 'AVARIA', cdTipo: 7, cdSubtipo: 54 },
        { label: 'AVARIA', cdTipo: 2, cdSubtipo: 27 },
        { label: 'ATRASO NA ENTREGA', cdTipo: 7, cdSubtipo: 32 },
        // { label: 'DEFEITO DE FABRICA / DESVIO DE QUALIDADE', cdTipo: 7, cdSubtipo: 55 },
        { label: 'DEFEITO DE FABRICA / DESVIO DE QUALIDADE', cdTipo: 6, cdSubtipo: 1 },
        { label: 'DIFERENCA DE PRECO', cdTipo: 7, cdSubtipo: 12 },
        { label: 'REPRESENTANTE/INDUSTRIA DIGITOU ERRADO', cdTipo: 7, cdSubtipo: 62 },
        { label: 'CLIENTE DIGITOU ERRADO', cdTipo: 7, cdSubtipo: 63 },
        { label: 'FORA DA TEMPERATURA ADEQUADA', cdTipo: 7, cdSubtipo: 37 },
        { label: 'MERCADORIA NAO SOLICITADA', cdTipo: 7, cdSubtipo: 61 },
        //{ label: 'PEDIDO NAO SOLICITADO', cdTipo: 7, cdSubtipo: 56 },
        { label: 'PRODUTO COM VENCIMENTO CURTO', cdTipo: 7, cdSubtipo: 17 },
      //  { label: 'QUANTIDADE NAO SOLICITADA', cdTipo: 7, cdSubtipo: 58 },
        { label: 'RECALL', cdTipo: 7, cdSubtipo: 59 },
        { label: 'PRODUTO VENCIDO', cdTipo: 7, cdSubtipo: 18}
        // { label: 'RECALL', cdTipo: 21, cdSubtipo: 1 },
        //{ label: 'OUTROS', cdTipo: 7, cdSubtipo: 60 },
    ],
    'FALTA_MERCADORIA': [
        { label: 'FALTA DE MERCADORIA', cdTipo: 4, cdSubtipo: 6 },
        // { label: 'FALTA DE VOLUME', cdTipo: 8, cdSubtipo: 43 },
        // { label: 'FALTA DE VOLUME E MERCADORIA', cdTipo: 0, cdSubtipo: 0 },
    ],
    'SOBRA_MERCADORIA': [
        { label: 'FALTA DE MERCADORIA', cdTipo: 4, cdSubtipo: 6 },
        { label: 'MERCADORIA ENVIADA EM EXCESSO', cdTipo: 20, cdSubtipo: 2 },
        { label: 'MERCADORIA NAO PERTENCE A NF', cdTipo: 20, cdSubtipo: 3 },
    ],
    'SOLICITACAO': [
        { label: 'CARTA DE CORRECAO DE DATA VALIDADE', cdTipo: 1, cdSubtipo: 32 },
        { label: 'CARTA DE CORRECAO DE LOTE', cdTipo: 1, cdSubtipo: 15 },
        { label: 'CARTA DE CORRECAO DE NOTA', cdTipo: 1, cdSubtipo: 16 },
        //{ label: 'REEMBOLSO FINANCEIRO', cdTipo: 1, cdSubtipo: 35 },
        { label: 'COPIA DE MINUTA', cdTipo: 1, cdSubtipo: 14 },
    ]
};

class SacService {
    constructor() {
        this.apiUrl = process.env.REACT_APP_API_URL || "https://portalrelacionamentoapi.dev-gam.com"; // URL do backend
        // this.apiUrl = "http://localhost:5000"; // URL do seu backend Java
    }
 

    async registrarOcorrencia(dadosOcorrencia, imagens = []) {
      try {
          // Autenticação
          if (!AuthService.getToken()) {
              await AuthService.login();
          }

          const url = `${this.apiUrl}/ocorrencia/registrar`;
          
          // CRIA O FORMDATA
          const formData = new FormData();
          
          // 1. Adiciona o JSON como string na parte "ocorrencia"
          const ocorrencia = formData.append("ocorrencia", JSON.stringify(dadosOcorrencia));
          console.log('🚀 DEBUG - ocorrencia:', ocorrencia);

          // 2. Adiciona as imagens na parte "imagens"
          if (imagens && imagens.length > 0) {
              imagens.forEach((file) => {
                  formData.append("imagens", file);
              });
          }

          // MUDANÇA NO HEADER: Content-Type agora é multipart/form-data
          // (Na verdade, deixamos o axios definir o boundary automaticamente removendo o 'application/json')
          const response = await axios.post(url, formData, {
              headers: {
                  Authorization: `Bearer ${AuthService.getActiveToken()}`,
                  // "Content-Type": "application/json", <--- REMOVA ESTA LINHA
                  // O axios detecta FormData e configura o multipart corretamente sozinho
              },
          });

          return response.data;
      } catch (error) {
          console.error("Erro ao registrar a ocorrência:", error);
          throw error;
      }
    }

    async consultarNotaFiscal(cdCliente, nrNfe, dtEmissao) {
        try {
            if (!AuthService.getToken()) {
                await AuthService.login();
            }

            const params = { cdCliente, nrNfe, dtEmissao };
            const url = `${this.apiUrl}/nota-fiscal-consulta/consultar`;

            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${AuthService.getActiveToken()}`,
                },
                params: params,
                timeout: 300000
            });

            return response.data;
        } catch (error) {
            // Se der timeout, o código do erro geralmente é 'ECONNABORTED'
            if (error.code === 'ECONNABORTED') {
              console.error("A consulta demorou mais de 5 minutos e foi cancelada.");
            }
            console.error("Erro ao consultar a nota fiscal:", error);
            throw error;
        }
    }

    async consultarMercadoriaPorEAN(ean) {
      try {
        if (!AuthService.getToken()) {
          await AuthService.login();
        }
    
        const url = `${this.apiUrl}/mercadoria/consultar-ean`;
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${AuthService.getActiveToken()}`,
          },
          params: { ean: ean.trim() }
        });
    
        return response.data;
      } catch (error) {
        console.error("Erro ao consultar mercadoria por EAN:", error);
        throw error;
      }
    }

    async consultarOcorrencias(cdCliente, filtros) {
        try {
          if (!AuthService.getToken()) {
            await AuthService.login();
          }

            // LOGS DE DEBUG - ADICIONE ESTAS LINHAS
            console.log('=================== DEBUG CONSULTA ===================');
            console.log('🔍 cdCliente:', cdCliente);
            console.log('🔍 Filtros recebidos:', filtros);
            console.log('🔍 dtRegistroInicial:', filtros.dtRegistroInicial);
            console.log('🔍 dtRegistroFinal:', filtros.dtRegistroFinal);
            console.log('🔍 dtEmissaoInicial:', filtros.dtEmissaoInicial);
            console.log('🔍 dtEmissaoFinal:', filtros.dtEmissaoFinal);
            console.log('🔍 cdOcorrencia:', filtros.cdOcorrencia);
            console.log('🔍 nrNfe:', filtros.nrNfe);
      
            // Verificar qual tipo de consulta fazer baseado nos filtros
            const temFiltroData = (filtros.dtRegistroInicial && filtros.dtRegistroFinal) || 
            (filtros.dtEmissaoInicial && filtros.dtEmissaoFinal);

            const temFiltroOcorrencia = !!filtros.cdOcorrencia; // ADICIONE !! para converter para boolean
            const temFiltroNfe = !!filtros.nrNfe; // ADICIONE !! para converter para boolean

            console.log('🔍 temFiltroData:', !!temFiltroData); // ADICIONE !! para mostrar como boolean
            console.log('🔍 temFiltroOcorrencia:', temFiltroOcorrencia);
            console.log('🔍 temFiltroNfe:', temFiltroNfe);
      
          let url;
          let filtrosFormatados;
      
          // Se tem filtro de data, usa o endpoint consultar-por-data
          if (temFiltroData && !temFiltroOcorrencia && !temFiltroNfe) {
            url = `${this.apiUrl}/consulta-ocorrencia/consultar`;
            console.log('🚀 USANDO ENDPOINT: consultar-por-data');

            filtrosFormatados = {
              cdCliente,
              dtRegistroInicial: filtros.dtRegistroInicial ? format(filtros.dtRegistroInicial, 'dd/MM/yyyy') : null,
              dtRegistroFinal: filtros.dtRegistroFinal ? format(filtros.dtRegistroFinal, 'dd/MM/yyyy') : null,
              dtEmissaoInicial: filtros.dtEmissaoInicial ? format(filtros.dtEmissaoInicial, 'dd/MM/yyyy') : null,
              dtEmissaoFinal: filtros.dtEmissaoFinal ? format(filtros.dtEmissaoFinal, 'dd/MM/yyyy') : null,
            };
          } 
          // Se tem filtro de ocorrência ou NFe, usa o endpoint consultar
          else {
            url = `${this.apiUrl}/consulta-ocorrencia/consultar`;
            console.log('🚀 USANDO ENDPOINT: consultar');

            filtrosFormatados = {
              cdCliente,
              cdOcorrencia: filtros.cdOcorrencia || null,
              nrNfe: filtros.nrNfe || null,
              dtRegistroInicial: filtros.dtRegistroInicial ? format(filtros.dtRegistroInicial, 'dd/MM/yyyy') : null,
              dtRegistroFinal: filtros.dtRegistroFinal ? format(filtros.dtRegistroFinal, 'dd/MM/yyyy') : null,
              dtEmissaoInicial: filtros.dtEmissaoInicial ? format(filtros.dtEmissaoInicial, 'dd/MM/yyyy') : null,
              dtEmissaoFinal: filtros.dtEmissaoFinal ? format(filtros.dtEmissaoFinal, 'dd/MM/yyyy') : null,
            };
          }

            console.log('🔗 URL FINAL:', url); // ADICIONE ESTA LINHA
            console.log('📦 PARÂMETROS FINAIS:', filtrosFormatados); // ADICIONE ESTA LINHA
      
          const response = await axios.get(url, {
            headers: {
              Authorization: `Bearer ${AuthService.getActiveToken()}`,
            },
            params: filtrosFormatados
          });
          return response.data;
        } catch (error) {
          console.error("Erro ao consultar as ocorrências:", error);
          throw error;
        }
      }
}

export default new SacService();